import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fc897b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pa-8 v-step-close-modal",
  id: "v-step-resumo-tab-notas-close"
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "d-flex align-center" }

import { withDefaults, ref, watch } from 'vue';

interface IProps {
  show: any;
  disabled?: boolean;
  width?: string;
  heigth?: string;
  icon?: string;
  iconColor?: string;
  el?: any;
  title: string;
  subtitle?: string;
  btnCloseText?: string;
  btnConfirmText?: string;
  paddingY?: string;
  btnConfitmDisabled?: boolean
  hasBtnClose?: boolean
  hasBtnConfirm?: boolean
  showFooter?: boolean
  persistent?: boolean
  showHeader?: boolean
  closeBody?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModal',
  props: {
    show: {},
    disabled: { type: Boolean, default: false },
    width: { default: '477px' },
    heigth: {},
    icon: {},
    iconColor: {},
    el: { default: 'div' },
    title: {},
    subtitle: {},
    btnCloseText: { default: 'Cancelar' },
    btnConfirmText: { default: 'Importar' },
    paddingY: { default: '0px' },
    btnConfitmDisabled: { type: Boolean },
    hasBtnClose: { type: Boolean, default: true },
    hasBtnConfirm: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    persistent: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
    closeBody: { type: Boolean, default: false }
  },
  emits: ['handleCancel', 'handleConfirm'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const dialog = ref<boolean>(props.show);

function handleConf() {
  return props.el !== 'form' ? handleConfirm() : '';
}
function handleCancel() {
  emit('handleCancel');
}
function handleConfirm() {
  emit('handleConfirm');
}

function close() {
  emit('handleCancel', 'fecha');
}

watch(
  () => props.show,
  () => (dialog.value = props.show)
);
watch(
  () => dialog.value,
  (nvalue) => {
    if (!nvalue)
      emit('handleCancel', dialog.value)
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: props.persistent,
    width: props.width,
    height: props.heigth
  }, {
    default: _withCtx(() => [
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
              ]),
              _createVNode(_component_v_btn, {
                icon: "",
                dark: "",
                size: "small",
                onClick: close,
                class: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.el), {
        onSubmit: _withModifiers(handleConfirm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "body-modal pb-6",
            style: _normalizeStyle({ padding: `${props.paddingY ? props.paddingY : '0'} 32px` }),
            id: "v-step-resumo-tab-notas"
          }, [
            _renderSlot(_ctx.$slots, "body")
          ], 4),
          (_ctx.showFooter)
            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.showFooter)
            ? (_openBlock(), _createBlock(_component_v_footer, {
                key: 1,
                class: "d-flex justify-end pa-0 pa-8 rounded-xl",
                style: {"gap":"16px"}
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "footer")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 32))
    ]),
    _: 3
  }, 8, ["modelValue", "persistent", "width", "height"]))
}
}

})